import * as Fetch from '../data/Fetch';

const setLocalizationFetchingType = 'SET_LOCALIZATION_FETCHING';
const setLocalizationType = 'SET_LOCALIZATION';

const initialState = {
    account: '',
    appTitle: '',
    badInputError: '',
    create: '',
    fetching: false,
    home: '',
    password: '',
    patient: '',
    record: '',
    signIn: '',
    signOut: '',
    site: '',
    sponsor: '',
    study: '',
    userName: ''
};

export const actionCreators = {
    getAllStrings: () => async (dispatch, getState) => {
        const state = getState().localizer;
        if (state.fetching ||
            state.appTitle !== '') {
            return;
        }
        const fetching = true;
        dispatch({ type: setLocalizationFetchingType, fetching });

        const allStrings = await Fetch.getRequest("localization", null);
        dispatch({ type: setLocalizationType, allStrings });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === setLocalizationFetchingType) {
        return {
            ...state,
            fetching: action.fetching
        };
    }

    if (action.type === setLocalizationType) {
        if (!action.allStrings ||
            !action.allStrings.map) {
            return {
                ...state,
                appTitle: 'Error',
                fetching: false
            };
        }

        var account = '';
        var appTitle = '';
        var badInputError = '';
        var create = '';
        var home = '';
        var password = '';
        var patient = '';
        var record = '';
        var signIn = '';
        var signOut = '';
        var site = '';
        var sponsor = '';
        var study = '';
        var userName = '';

        action.allStrings.map(local => {
            switch (local.name) {
                case 'account':
                    account = local.value;
                    break;
                case 'appTitle':
                    appTitle = local.value;
                    break;
                case 'badInputError':
                    badInputError = local.value;
                    break;
                case 'create':
                    create = local.value;
                    break;
                case 'home':
                    home = local.value;
                    break;
                case 'password':
                    password = local.value;
                    break;
                case 'patient':
                    patient = local.value;
                    break;
                case 'record':
                    record = local.value;
                    break;
                case 'signIn':
                    signIn = local.value;
                    break;
                case 'signOut':
                    signOut = local.value;
                    break;
                case 'site':
                    site = local.value;
                    break;
                case 'sponsor':
                    sponsor = local.value;
                    break;
                case 'study':
                    study = local.value;
                    break;
                case 'userName':
                    userName = local.value;
                    break;
                default:
                    break;
            }

            // Don't need to return a value since we are not mapping to a new array, but return null to avoid warning
            return null;
        });

        return {
            ...state,
            account: account,
            appTitle: appTitle,
            badInputError: badInputError,
            create: create,
            fetching: false,
            home: home,
            password: password,
            patient: patient,
            record: record,
            signIn: signIn,
            signOut: signOut,
            site: site,
            sponsor: sponsor,
            study: study,
            userName: userName
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/Localization.js